import {
  Self,
  Output,
  OnInit,
  Optional,
  Component,
  OnDestroy,
  EventEmitter,
  Input,
} from '@angular/core';
import { UntypedFormGroup, FormGroupDirective, FormGroupName } from '@angular/forms';

import { SnUser, SnNotificationType } from '@lib/api/entities';

// TODO Migrate to form generator
@Component({
  selector: 'sn-notification-form',
  templateUrl: './notification-form.component.html',
  styleUrls: ['./notification-form.component.scss'],
})
export class NotificationFormComponent implements OnInit, OnDestroy {
  @Output()
  public readonly notificationDeleted = new EventEmitter<void>();

  @Input()
  public options: SnUser[];

  @Input()
  public notificationTypes = [
    SnNotificationType.sms,
    SnNotificationType.email,
    SnNotificationType.push,
  ];

  public form: UntypedFormGroup;

  public hasUserId = null;

  constructor(
    @Optional() @Self() private readonly _formGroupName: FormGroupName,
    @Optional() @Self() private readonly _formGroup: FormGroupDirective,
  ) {}

  public ngOnInit(): void {
    this.form = this._formGroupName.control || this._formGroup.form;
  }

  public ngOnDestroy(): void {
    this.notificationDeleted.complete();
  }

  public trackNotificationType(index: number, item: string): any {
    return item;
  }

  public onUserSelect(user: SnUser): void {
    this.form.patchValue({
      email: user.email,
      mobilePhone: user.mobilePhone,
    });
  }

  public deleteNotification(): void {
    this.notificationDeleted.emit();
  }
}
